import {
    CREATE_PROVIDER,
    CREATE_PROVIDER_SUCCESS,
    CREATE_PROVIDER_API_ERROR,
    
    GET_POSTAL_CODE,
    GET_POSTAL_CODE_SUCCESS
} from "./actionTypes"

export const createProvider = (params, callBackSuccess) => {
    return {
        type: CREATE_PROVIDER,
        payload: {params, callBackSuccess}
    }
}

export const createProviderSuccess = data => {
    return {
        type: CREATE_PROVIDER_SUCCESS,
        payload: { data }
    }
}

export const apicreateProviderError = error => {
    return {
        type: CREATE_PROVIDER_API_ERROR,
        payload: { error },
    }
}


export const getPostalCode = params => {
    return {
        type: GET_POSTAL_CODE,
        payload: params,
        
    }
}

export const getPostalCodeSuccess = (data) => {
    return {
        type: GET_POSTAL_CODE_SUCCESS,
        payload:  data 
    }
}